import TeacherTypeList from "@/controllers/teacher_type/teacher-type-list";

export default {
  extends: TeacherTypeList,
}
